export default __webpack_public_path__ + "7f3edd1657386de3b7b0028b5baddbb6.gif";